// src/pages/categories/SmartWaterMonitor.jsx
import React, { useEffect, useState } from 'react';

// Import gambar Mobile Apps (Silakan coba ganti ke .JPG atau .jpeg jika masih error)
import mobile1 from '../../assets/images/air-cerdas/tampilan_mobile_apps-1.jpeg';
import mobile2 from '../../assets/images/air-cerdas/tampilan_mobile_apps-2.jpg';
import mobile3 from '../../assets/images/air-cerdas/tampilan_mobile_apps-3.jpeg';
import mobile4 from '../../assets/images/air-cerdas/tampilan_mobile_apps-4.jpeg';
import mobile5 from '../../assets/images/air-cerdas/tampilan_mobile_apps-5.jpeg';
import mobile6 from '../../assets/images/air-cerdas/tampilan_mobile_apps-6.jpeg';
import mobile7 from '../../assets/images/air-cerdas/tampilan_mobile_apps-7.jpeg';

// Import gambar Web Dashboard (Menggunakan .PNG huruf besar sesuai dengan error)
import web1 from '../../assets/images/air-cerdas/tampilan-web-dashboard-1.PNG';
import web2 from '../../assets/images/air-cerdas/tampilan-web-dashboard-2.PNG';
import web3 from '../../assets/images/air-cerdas/tampilan-web-dashboard-3.PNG';
import web4 from '../../assets/images/air-cerdas/tampilan-web-dashboard-4.PNG';
import web5 from '../../assets/images/air-cerdas/tampilan-web-dashboard-5.PNG';

// Import gambar ilustrasi titik pemasangan
import imgMonitoringTotal from '../../assets/images/air-cerdas/monitoring total.jpg';
import imgTitikKebocoran from '../../assets/images/air-cerdas/mengetahui titik kebocoran.jpg';

const SmartWaterMonitor = () => {
  // State untuk index carousel
  const [mobileIndex, setMobileIndex] = useState(0);
  const [webIndex, setWebIndex] = useState(0);

  const mobileImages = [mobile1, mobile2, mobile3, mobile4, mobile5, mobile6, mobile7];
  const webImages = [web1, web2, web3, web4, web5];

  // URL Marketplace
  const tokpedUrl = "https://www.tokopedia.com/solusi-iot-cerdas/sistem-pemantauan-air-berbasis-iot-pipa-1-2-inchi-air-cerdas-pantau-pengunaanan-air-berapa-liter-yang-digunakan-anti-bocor-hemat-tagihan-pdam-hemat-listrik-untuk-rumah-tinggal-kontrakan-kost-apartemen-kantor-1731948329540552102?extParam=whid%3D20289209%26src%3Dshop&aff_unique_id=&channel=others&chain_key=";
  const shopeeUrl = "https://shopee.co.id/Sistem-Pemantauan-Air-Berbasis-IoT-pipa-1-2-inch-Hemat-Air-Hemat-Listrik-Anti-Kebocoran-Air-i.1572877014.29388692719?extraParams=%7B%22display_model_id%22%3A270721254914%2C%22model_selection_logic%22%3A3%7D";

  useEffect(() => {
    // SEO Meta Tags
    const originalTitle = document.title;
    document.title = "Air Cerdas – Monitoring Air dari HP | Deteksi Kebocoran & Kontrol Tagihan Air";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Tagihan air tiba-tiba naik? Pantau pemakaian air langsung dari HP dengan Air Cerdas. Promo dari Rp400.000 jadi Rp190.000 per produk. Dapat video instalasi dan dibimbing sampai terpasang.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "air cerdas, smart water monitor, pantau air hp, deteksi kebocoran, kontrol tagihan air, alat penghemat air");

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) { ogTitle = document.createElement('meta'); ogTitle.setAttribute('property', 'og:title'); document.head.appendChild(ogTitle); }
    ogTitle.setAttribute('content', "Air Cerdas – Monitoring Air dari HP | Deteksi Kebocoran & Kontrol Tagihan Air");

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) { ogDescription = document.createElement('meta'); ogDescription.setAttribute('property', 'og:description'); document.head.appendChild(ogDescription); }
    ogDescription.setAttribute('content', "Tagihan air tiba-tiba naik? Pantau pemakaian air langsung dari HP dengan Air Cerdas. Promo dari Rp400.000 jadi Rp190.000 per produk.");

    // Timer Carousel
    const mobileTimer = setInterval(() => {
      setMobileIndex((prev) => (prev + 1) % mobileImages.length);
    }, 3000);

    const webTimer = setInterval(() => {
      setWebIndex((prev) => (prev + 1) % webImages.length);
    }, 4000);

    // Cleanup function
    return () => {
      document.title = originalTitle;
      const tagsToRemove = document.querySelectorAll(
        'meta[name="description"], meta[name="keywords"], meta[property^="og:"], meta[name^="twitter:"]'
      );
      tagsToRemove.forEach(tag => tag.remove());
      clearInterval(mobileTimer);
      clearInterval(webTimer);
    };
  }, [mobileImages.length, webImages.length]);

  return (
    <>
      <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-8 md:py-16 transition-colors duration-300 pb-24 md:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* 1. HERO SECTION */}
          <section className="text-center mb-16 pt-8">
            <div className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 font-semibold px-4 py-1 rounded-full text-sm mb-6">
              Air Cerdas — Smart Water Monitor
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-blue-700 dark:text-blue-400 leading-tight mb-6">
              Tagihan Air Tiba-Tiba Naik? <br className="hidden md:block" />
              <span className="text-gray-900 dark:text-white">Bisa Jadi Ada Kebocoran yang Tidak Terlihat.</span>
            </h1>
            <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300 mb-8 leading-relaxed">
              Dengan Air Cerdas, Anda bisa memantau pemakaian air langsung dari HP, lebih cepat sadar kalau ada lonjakan tidak wajar, dan lebih tenang mengontrol biaya air di rumah, kos, kontrakan, ruko, maupun apartemen.
            </p>

            {/* Promo Box Hero */}
            <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 md:p-8 mb-8 border border-blue-100 dark:border-gray-700">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="text-left">
                  <p className="text-sm font-bold text-red-500 uppercase tracking-wider mb-1">Promo Spesial Hari Ini</p>
                  <div className="flex items-baseline gap-3">
                    <span className="text-2xl text-gray-400 line-through decoration-red-500">Rp400.000</span>
                    <span className="text-4xl font-extrabold text-gray-900 dark:text-white">Rp190.000</span>
                    <span className="text-gray-500 dark:text-gray-400">/ produk</span>
                  </div>
                </div>
                <div className="text-left space-y-2">
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300"><span className="text-blue-600 font-bold mr-2">✓</span> Dapat video panduan instalasi</p>
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300"><span className="text-blue-600 font-bold mr-2">✓</span> Dibimbing sampai alat terpasang</p>
                  <p className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300"><span className="text-blue-600 font-bold mr-2">✓</span> Konsultasi gratis sebelum beli</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
              <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20tertarik%20dengan%20promo%20Air%20Cerdas%20Rp190.000.%20Bisa%20tanya-tanya%20dulu%3F" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 text-white font-bold px-8 py-4 rounded-full shadow-lg hover:bg-green-700 transform hover:scale-105 transition-all duration-300 text-lg">
                Chat WhatsApp Sekarang
              </a>
              <a href="#cara-kerja" className="inline-block bg-white dark:bg-gray-800 text-gray-800 dark:text-white font-bold px-8 py-4 rounded-full shadow border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transform hover:scale-105 transition-all duration-300 text-lg">
                Lihat Cara Kerjanya
              </a>
            </div>

            {/* Marketplace Buttons */}
            <div className="pt-6">
               <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">Atau beli dengan aman & nyaman melalui Marketplace resmi kami:</p>
               <div className="flex flex-col sm:flex-row justify-center gap-4">
                 <a href={tokpedUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#00AA5B] text-white font-bold px-6 py-3 rounded-xl shadow-md hover:bg-[#008f4c] transition-colors">
                   Belanja di Tokopedia
                 </a>
                 <a href={shopeeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#EE4D2D] text-white font-bold px-6 py-3 rounded-xl shadow-md hover:bg-[#d74223] transition-colors">
                   Belanja di Shopee
                 </a>
               </div>
            </div>
          </section>

          {/* 2. SECTION PEMBUKA & MASALAH NYATA */}
          <section className="mb-16">
            <div className="bg-white dark:bg-gray-800 p-8 md:p-12 rounded-3xl shadow-md transition-colors duration-300 mb-8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6 leading-tight">Ada Tagihan Air yang Seharusnya Tidak Perlu Anda Bayar</h2>
                  <div className="space-y-4 text-lg text-gray-700 dark:text-gray-300">
                    <p>Banyak orang mengira tagihan air yang naik itu hal biasa. Padahal sering kali masalahnya bukan karena pemakaian bertambah banyak, melainkan karena ada kebocoran kecil, aliran yang terus jalan, atau penggunaan yang tidak terkontrol.</p>
                    <p>Masalahnya, kebocoran air tidak selalu terlihat. Tidak selalu ada genangan. Tidak selalu ada pipa yang pecah besar. Kadang justru yang paling merugikan adalah kebocoran kecil yang jalan diam-diam selama berjam-jam, bahkan berhari-hari.</p>
                    <p className="font-semibold text-red-600 dark:text-red-400">Dan seperti biasa, Anda baru sadar saat tagihan sudah datang.</p>
                    <p>Air Cerdas hadir untuk menghentikan pola itu. Bukan dengan tebakan. Bukan dengan kira-kira. Tapi dengan data pemakaian air yang bisa Anda lihat langsung dari handphone.</p>
                  </div>
                </div>
                <div className="flex justify-center">
                  <img src="/images/masalah-tagihan-air.webp" alt="Ilustrasi Tagihan Air Membengkak" className="rounded-2xl shadow-xl w-full h-auto max-w-md object-cover" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-red-50 dark:bg-red-900/20 p-8 rounded-3xl border border-red-100 dark:border-red-900/30">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Masalah Bukan Hanya Soal Banyak Dipakai</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">Yang sering terjadi di lapangan adalah karena tidak terpantau:</p>
                <ul className="space-y-3 text-gray-700 dark:text-gray-300">
                  <li className="flex items-start"><span className="text-red-500 font-bold mr-2">-</span> Ada rembesan kecil yang dibiarkan</li>
                  <li className="flex items-start"><span className="text-red-500 font-bold mr-2">-</span> Ada pemakaian air yang tidak terkontrol</li>
                  <li className="flex items-start"><span className="text-red-500 font-bold mr-2">-</span> Ada lonjakan yang tidak terdeteksi sejak awal</li>
                  <li className="flex items-start"><span className="text-red-500 font-bold mr-2">-</span> Tidak ada data harian yang mudah dipantau</li>
                </ul>
              </div>
              <div className="bg-blue-50 dark:bg-blue-900/20 p-8 rounded-3xl border border-blue-100 dark:border-blue-900/30">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Kenapa Cek Manual Tidak Cukup?</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">Sebagian orang mencoba mengecek manual (melihat meter air). Tapi air tidak selalu boros di depan mata. Kebocoran bisa terjadi malam hari, atau saat Anda sedang pergi.</p>
                <p className="text-gray-700 dark:text-gray-300 font-semibold mb-2">Kalau Anda masih mengandalkan tebakan, Anda selalu terlambat.</p>
                <p className="text-gray-700 dark:text-gray-300 italic">"Karena yang membuat orang rugi bukan cuma airnya. Yang membuat orang rugi adalah terlambat sadar."</p>
              </div>
            </div>
          </section>

          {/* 3. SOLUSI & KEUNGGULAN UTAMA */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 md:p-12 rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 transition-colors duration-300">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Solusinya: Air Cerdas</h2>
              <p className="text-xl text-blue-600 dark:text-blue-400 font-medium">Monitoring air yang lebih praktis, modern, dan mudah dipantau dari handphone.</p>
            </div>
            
            <p className="text-lg text-gray-700 dark:text-gray-300 max-w-4xl mx-auto text-center mb-12">
              Air Cerdas adalah solusi pemantauan air yang membantu Anda melihat penggunaan air dengan lebih mudah. Anda tidak perlu terus-terusan menebak penyebab tagihan naik. Anda tidak perlu menunggu sampai akhir bulan untuk curiga ada masalah.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-4 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Pantau dari HP</h3>
                <p className="text-gray-600 dark:text-gray-400">Lihat pemakaian air dengan lebih praktis tanpa harus menebak-nebak.</p>
              </div>
              <div className="p-4 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Lebih Cepat Sadar Lonjakan</h3>
                <p className="text-gray-600 dark:text-gray-400">Begitu pemakaian terasa tidak normal, Anda bisa lebih cepat curiga dan mengambil tindakan.</p>
              </div>
              <div className="p-4 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Lebih Tenang Mengontrol Biaya</h3>
                <p className="text-gray-600 dark:text-gray-400">Bukan sekadar melihat air dipakai, tapi lebih sadar ke mana biaya Anda berjalan.</p>
              </div>
              <div className="p-4 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Cocok Untuk Sehari-hari</h3>
                <p className="text-gray-600 dark:text-gray-400">Sangat ideal untuk rumah, kos, kontrakan, ruko, hingga bangunan sewa kecil.</p>
              </div>
            </div>
          </section>

          {/* 4. CARA KERJA */}
          <section id="cara-kerja" className="mb-16 bg-gray-50 dark:bg-gray-900/50 p-8 md:p-12 rounded-3xl transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white text-center mb-12">Cara Kerjanya Sederhana</h2>
            <div className="flex flex-col md:flex-row items-start justify-center gap-8 md:gap-4 relative">
              <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-1 bg-blue-200 dark:bg-blue-800/50 z-0"></div>
              
              <div className="flex-1 flex flex-col items-center text-center relative z-10">
                <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold mb-4 border-4 border-white dark:border-gray-900">1</div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Alat Dipasang di Jalur Air</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Air Cerdas dipasang untuk membantu membaca aliran air yang digunakan secara akurat.</p>
              </div>

              <div className="flex-1 flex flex-col items-center text-center relative z-10">
                <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold mb-4 border-4 border-white dark:border-gray-900">2</div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Sistem Terhubung</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Setelah aktif dan terhubung Wi-Fi, Anda bisa mulai melihat pemantauan dari handphone.</p>
              </div>

              <div className="flex-1 flex flex-col items-center text-center relative z-10">
                <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold mb-4 border-4 border-white dark:border-gray-900">3</div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Pantau Lebih Mudah</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Kalau ada lonjakan pemakaian yang tidak wajar, Anda tidak lagi sepenuhnya buta.</p>
              </div>
            </div>
            <p className="text-center font-medium text-gray-700 dark:text-gray-300 mt-10">Bukan ribet. Justru tujuan Air Cerdas adalah membuat kontrol air jadi lebih sederhana dan lebih mudah dipahami.</p>
          </section>

          {/* 5. CARA MENENTUKAN TITIK PEMASANGAN */}
          <section className="mb-16">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Pasang di Mana? Sesuaikan dengan Tujuan Monitoring Anda</h2>
              <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">Air Cerdas bisa dipasang sesuai kebutuhan Anda. Karena tidak semua orang punya tujuan yang sama, maka titik pemasangan sensor juga bisa berbeda. Ada yang ingin mengetahui total pemakaian air seluruh bangunan, ada juga yang ingin mengetahui kebocoran. Kabar baiknya, semuanya bisa dimulai secara bertahap.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
              {/* Opsi 1 */}
              <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-sm border border-gray-100 dark:border-gray-700 flex flex-col h-full overflow-hidden">
                <img 
                  src={imgMonitoringTotal} 
                  alt="Monitoring Total Pemakaian Air" 
                  className="w-full h-48 object-cover border-b border-gray-100 dark:border-gray-700"
                />
                <div className="p-8 flex flex-col flex-grow">
                  <div className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 font-bold px-3 py-1 rounded-full text-sm mb-4 self-start">Opsi 1</div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Jika Anda Ingin Tahu Total Pemakaian Air</h3>
                  <p className="font-semibold text-blue-600 dark:text-blue-400 mb-4 text-sm">Pasang sensor di jalur utama, dekat tandon atau sumber distribusi utama</p>
                  <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">Kalau tujuan Anda adalah memantau seluruh pemakaian air secara umum, maka sensor paling ideal dipasang di jalur utama air, misalnya dekat tandon atau pada pipa distribusi utama sebelum air dibagi ke beberapa titik.</p>
                  <div className="mb-4">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-200 mb-2">Dengan pemasangan ini, Anda bisa:</p>
                    <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>melihat total air yang digunakan</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>memahami pola pemakaian harian secara umum</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>mulai mengenali apakah penggunaan normal/tidak</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>menjadikan sensor ini sebagai titik kontrol utama</li>
                    </ul>
                  </div>
                  <div className="mt-auto pt-4 border-t border-gray-100 dark:border-gray-700">
                    <p className="text-xs text-gray-500 dark:text-gray-400 italic">Ini adalah pilihan paling cocok untuk Anda yang ingin memantau pemakaian total terlebih dahulu dan melakukan percobaan awal.</p>
                  </div>
                </div>
              </div>

              {/* Opsi 2 */}
              <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-sm border border-gray-100 dark:border-gray-700 flex flex-col h-full overflow-hidden">
                <img 
                  src={imgTitikKebocoran} 
                  alt="Mengetahui Titik Kebocoran Air" 
                  className="w-full h-48 object-cover border-b border-gray-100 dark:border-gray-700"
                />
                <div className="p-8 flex flex-col flex-grow">
                  <div className="inline-block bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 font-bold px-3 py-1 rounded-full text-sm mb-4 self-start">Opsi 2</div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Jika Anda Ingin Mengetahui Titik Kebocoran</h3>
                  <p className="font-semibold text-green-600 dark:text-green-400 mb-4 text-sm">Pasang sensor di tiap jalur yang mengarah ke keran atau titik pemakaian tertentu</p>
                  <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">Kalau tujuan Anda adalah mencari tahu keran atau jalur mana yang bocor, maka sensor perlu dipasang lebih spesifik, yaitu pada setiap titik aliran yang ingin dipantau (misal: jalur ke dapur, kamar mandi, area cuci, dll).</p>
                  <div className="mb-4">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-200 mb-2">Dengan cara ini, Anda bisa lebih mudah mengetahui:</p>
                    <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>titik mana yang terus mengalir</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>jalur mana yang pemakaiannya tidak wajar</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>keran mana yang kemungkinan bocor/rembes</li>
                      <li><span className="text-blue-600 font-bold mr-2">✓</span>area mana yang paling banyak memakai air</li>
                    </ul>
                  </div>
                  <div className="mt-auto pt-4 border-t border-gray-100 dark:border-gray-700">
                    <p className="text-xs text-gray-500 dark:text-gray-400 italic">Semakin detail titik pemasangan, semakin detail juga informasi yang bisa Anda dapatkan.</p>
                  </div>
                </div>
              </div>

              {/* Opsi 3 */}
              <div className="bg-white dark:bg-gray-800 p-8 rounded-3xl shadow-sm border border-gray-100 dark:border-gray-700 flex flex-col h-full">
                <div className="inline-block bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 font-bold px-3 py-1 rounded-full text-sm mb-4 self-start">Opsi 3</div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Jika Anda Baru Mau Coba Dulu</h3>
                <p className="font-semibold text-yellow-600 dark:text-yellow-400 mb-4 text-sm">Mulai dari 1 sensor dulu di tandon atau jalur utama</p>
                <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">Kalau Anda masih ingin mencoba dulu dan memahami produk ini secara bertahap, Anda tidak harus langsung pasang banyak sensor. Cukup pasang 1 sensor di dekat tandon atau jalur utama.</p>
                <div className="mb-4">
                  <p className="text-sm font-semibold text-gray-900 dark:text-gray-200 mb-2">Ini adalah cara paling sederhana untuk:</p>
                  <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1">
                    <li><span className="text-blue-600 font-bold mr-2">✓</span>mengenal cara kerja Air Cerdas</li>
                    <li><span className="text-blue-600 font-bold mr-2">✓</span>melihat bagaimana data monitoring tampil</li>
                    <li><span className="text-blue-600 font-bold mr-2">✓</span>memahami manfaat sistem secara langsung</li>
                  </ul>
                </div>
                <div className="mt-auto pt-4 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-xs text-gray-500 dark:text-gray-400 italic">Setelah Anda merasa cocok dan mulai memahami pola pemakaian air, barulah sistem bisa diperluas ke titik-titik yang spesifik.</p>
                </div>
              </div>
            </div>

            {/* Kesimpulan */}
            <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-2xl border border-blue-100 dark:border-blue-900/30 max-w-4xl mx-auto">
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4 text-center">Jadi, Pilih Titik Pemasangan Berdasarkan Tujuan Anda</h4>
              <ul className="space-y-3 text-gray-700 dark:text-gray-300 text-sm md:text-base">
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 font-bold text-lg leading-none"></span> 
                  <p>Kalau <strong>ingin tahu total pemakaian air</strong>, pasang di dekat tandon atau jalur utama.</p>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 font-bold text-lg leading-none"></span> 
                  <p>Kalau <strong>ingin tahu titik kebocoran secara spesifik</strong>, pasang di setiap jalur menuju keran atau titik pemakaian.</p>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-3 font-bold text-lg leading-none"></span> 
                  <p>Kalau <strong>baru ingin mencoba</strong>, cukup mulai dengan 1 sensor dulu.</p>
                </li>
              </ul>
            </div>
          </section>

          {/* 6. TARGET AUDIENCE */}
          <section className="mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white text-center mb-4">Air Cerdas Cocok untuk Siapa?</h2>
            <p className="text-center text-gray-600 dark:text-gray-400 mb-10 text-lg">Kalau Anda termasuk salah satu di bawah ini, kemungkinan besar Anda memang butuh Air Cerdas.</p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <img src="/images/targets/target-kosan.webp" alt="Pemilik Kos" className="mb-4 w-16 h-16 object-contain" />
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">1. Pemilik Kos</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Sedikit kebocoran atau penggunaan berlebihan oleh anak kos bisa langsung memakan margin usaha Anda.</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <img src="/images/targets/target-ruko.webp" alt="Pemilik Kontrakan" className="mb-4 w-16 h-16 object-contain" />
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">2. Pemilik Kontrakan</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Semakin banyak unit, makin besar potensi pemborosan tak terpantau. Mulai miliki kontrol sekarang.</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <img src="/images/targets/target-ruko.webp" alt="Pemilik Ruko" className="mb-4 w-16 h-16 object-contain" />
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">3. Pemilik Ruko / Usaha</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Aliran air yang terus jalan menaikkan biaya operasional diam-diam. Monitoring membuat pengeluaran terukur.</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <img src="/images/targets/target-perumahan.webp" alt="Pemilik Rumah" className="mb-4 w-16 h-16 object-contain" />
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">4. Pemilik Rumah</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Sering mengalami lonjakan tagihan tanpa tahu penyebabnya? Lebih cepat sadar kalau ada yang tidak normal.</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 lg:col-span-2">
                <img src="/images/targets/target-apartemen.webp" alt="Pengelola Apartemen" className="mb-4 w-16 h-16 object-contain" />
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">5. Pengelola Apartemen Kecil / Sewa</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">Langkah awal yang ringan dan efektif untuk memantau penggunaan air secara modern.</p>
              </div>
            </div>
            <div className="mt-8 text-center bg-blue-50 dark:bg-blue-900/20 p-4 rounded-xl">
              <p className="font-semibold text-blue-800 dark:text-blue-300">Intinya sederhana: kalau Anda tidak suka tagihan air yang naik tanpa alasan jelas, Air Cerdas dibuat untuk Anda.</p>
            </div>
          </section>

          {/* 7. OFFER / PRICING & HILANGKAN TAKUT INSTALASI */}
          <section className="mb-16">
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white p-8 md:p-12 rounded-3xl shadow-xl">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl md:text-4xl font-bold mb-4">Promo Spesial Hari Ini</h2>
                  <p className="text-blue-100 mb-6 text-lg">Kalau selama ini Anda menunda karena merasa alat monitoring air itu mahal atau terlalu ribet, sekarang saatnya mulai dari versi yang lebih ringan.</p>
                  
                  <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20 mb-6">
                    <div className="flex items-baseline gap-4 mb-2">
                      <span className="text-2xl text-blue-300 line-through decoration-red-400">Rp400.000</span>
                      <span className="text-5xl font-extrabold text-white">Rp190.000</span>
                    </div>
                    <p className="text-sm text-blue-200">/ produk</p>
                  </div>

                  <p className="text-sm text-blue-100 italic mb-6">Harga promo ini cocok untuk Anda yang ingin mulai memasang secara bertahap, mencoba di satu titik, atau membangun kontrol tanpa biaya besar di awal.</p>
                  
                  {/* Buttons Container */}
                  <div className="flex flex-col gap-5">
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20mau%20order%20Air%20Cerdas%20harga%20promo%20180rb" target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-green-500 text-white font-bold px-6 py-3 rounded-full hover:bg-green-600 transition-colors shadow">
                        Saya Mau Order via WA
                      </a>
                      <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20tertarik%20tapi%20mau%20tanya%20dulu%20soal%20Air%20Cerdas" target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-white text-blue-700 font-bold px-6 py-3 rounded-full hover:bg-gray-100 transition-colors shadow">
                        Saya Mau Tanya Dulu
                      </a>
                    </div>
                    
                    {/* Marketplace Links in Promo Section */}
                    <div className="mt-2 border-t border-blue-500/30 pt-4">
                       <p className="text-sm text-blue-100 mb-3 text-center sm:text-left">Tersedia juga di Marketplace resmi kami:</p>
                       <div className="flex flex-col sm:flex-row gap-3">
                         <a href={tokpedUrl} target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-[#00AA5B] text-white font-bold px-4 py-2 rounded-xl shadow hover:bg-[#008f4c] transition-colors">
                           Beli di Tokopedia
                         </a>
                         <a href={shopeeUrl} target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-[#EE4D2D] text-white font-bold px-4 py-2 rounded-xl shadow hover:bg-[#d74223] transition-colors">
                           Beli di Shopee
                         </a>
                       </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white p-8 rounded-2xl shadow-lg">
                  <h3 className="text-2xl font-bold mb-4">Tenang, Anda Tidak Dibiarkan Pasang Sendiri</h3>
                  <p className="text-gray-600 dark:text-gray-400 mb-6 text-sm">Takut instalasi membingungkan? Takut beli tapi alat tak terpakai? Kami pastikan alatnya benar-benar bisa Anda gunakan.</p>
                  
                  <ul className="space-y-4 mb-6">
                    <li className="flex items-start">
                      <span className="text-blue-600 font-bold mr-3 text-xl">✓</span>
                      <div>
                        <strong className="block">Video Panduan Instalasi</strong>
                        <span className="text-sm text-gray-500 dark:text-gray-400">Proses awal lebih mudah diikuti.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 font-bold mr-3 text-xl">✓</span>
                      <div>
                        <strong className="block">Dibimbing Sampai Terpasang</strong>
                        <span className="text-sm text-gray-500 dark:text-gray-400">Kalau bingung, Anda tidak dibiarkan sendiri.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 font-bold mr-3 text-xl">✓</span>
                      <div>
                        <strong className="block">Konsultasi Kendala</strong>
                        <span className="text-sm text-gray-500 dark:text-gray-400">Tujuan kami alat bukan cuma sampai, tapi terpakai.</span>
                      </div>
                    </li>
                  </ul>
                  <p className="font-semibold text-blue-600 dark:text-blue-400 text-sm text-center">Jadi Anda tidak perlu merasa harus jago teknis dulu.</p>
                </div>
              </div>
            </div>
          </section>

          {/* 8. VALUE / WHY BUY NOW */}
          <section className="mb-16 text-center max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Anda Tidak Sedang Membeli Alat. Anda Sedang Membeli Kendali.</h2>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-3xl shadow-sm border border-gray-100 dark:border-gray-700">
              <p className="text-lg text-gray-700 dark:text-gray-300 mb-4">Masalah terbesar dalam tagihan air bukan cuma soal air yang keluar. <strong>Masalah terbesarnya adalah Anda tidak tahu kapan, di mana, dan seberapa besar pemborosan itu terjadi.</strong></p>
              
              <div className="bg-gray-50 dark:bg-gray-900 p-6 rounded-xl my-6 text-left max-w-md mx-auto">
                <p className="font-semibold mb-3 text-gray-900 dark:text-white">Air Cerdas membantu Anda beralih dari:</p>
                <ul className="space-y-2 text-gray-700 dark:text-gray-300 list-disc list-inside">
                  <li>Tidak tahu <span className="font-bold text-blue-600 dark:text-blue-400">menjadi lebih tahu</span></li>
                  <li>Hanya curiga <span className="font-bold text-blue-600 dark:text-blue-400">menjadi bisa memantau</span></li>
                  <li>Terlambat sadar <span className="font-bold text-blue-600 dark:text-blue-400">menjadi lebih cepat bertindak</span></li>
                </ul>
              </div>

              <p className="text-gray-700 dark:text-gray-300 italic">Kalau dipikir-pikir, harga promo Rp190.000 jauh lebih kecil dibanding potensi kerugian yang terus berulang setiap bulan.</p>
            </div>
          </section>

          {/* 9. MEDIA: VIDEO & SCREENSHOT APP */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 md:p-12 rounded-3xl shadow-md border border-gray-100 dark:border-gray-700 transition-colors duration-300">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Lihat Langsung Produk & Aplikasinya</h2>
              <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">Kami tahu, banyak orang lebih yakin setelah melihat bentuk produknya secara langsung dan bagaimana tampilannya saat dipantau. Lihat cara kerjanya secara singkat sebelum memutuskan beli.</p>
            </div>

            {/* Baris Video */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-16">
              <div>
                <h3 className="text-xl font-bold text-center mb-6 text-gray-900 dark:text-white">Video Cara Kerja Lengkap</h3>
                <div className="aspect-w-16 aspect-h-9 w-full rounded-2xl overflow-hidden shadow-lg bg-gray-200 dark:bg-gray-700">
                  <iframe
                    src="https://www.youtube.com/embed/1L5tFK0DLF8"
                    title="Pasang Alat ini langsung Hemat Air Hemat Listrik"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-bold text-center mb-6 text-gray-900 dark:text-white">Cuplikan Singkat (Shorts)</h3>
                <div className="aspect-w-9 aspect-h-10 w-full max-w-xs mx-auto rounded-2xl overflow-hidden shadow-lg bg-gray-200 dark:bg-gray-700">
                  <iframe
                    src="https://www.youtube.com/embed/JTTAFbhrY9w"
                    title="Pasang Alat ini Pasti Hemat Air"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Baris Mockup Aplikasi (Web & Mobile Carousel) */}
            <div className="border-t border-gray-200 dark:border-gray-700 pt-12">
               <h3 className="text-2xl font-bold text-center mb-10 text-gray-900 dark:text-white">Tampilan Monitoring di berbagai Perangkat</h3>
               <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                  
                  {/* Web Dashboard Slider */}
                  <div>
                    <h4 className="text-lg font-bold text-center mb-6 text-gray-900 dark:text-white">Web Dashboard (Laptop/PC)</h4>
                    <div className="mx-auto w-full max-w-lg">
                      {/* Frame Layar Laptop */}
                      <div className="relative bg-gray-800 border-gray-800 border-[8px] rounded-t-xl shadow-xl aspect-video">
                        <div className="overflow-hidden relative w-full h-full bg-white group">
                           <img 
                             src={webImages[webIndex]} 
                             className="w-full h-full object-cover transition-opacity duration-500" 
                             alt={`Tampilan Web ${webIndex + 1}`} 
                           />
                           
                           {/* Tombol Manual Kiri & Kanan */}
                           <button onClick={() => setWebIndex(prev => prev === 0 ? webImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 text-white w-8 h-8 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80 font-bold">‹</button>
                           <button onClick={() => setWebIndex(prev => (prev + 1) % webImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 text-white w-8 h-8 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80 font-bold">›</button>
                        </div>
                      </div>
                      {/* Frame Keyboard Laptop */}
                      <div className="relative bg-gray-400 dark:bg-gray-600 h-4 rounded-b-2xl shadow-2xl">
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-1 bg-gray-300 dark:bg-gray-500 rounded-b-md"></div>
                      </div>
                      
                      {/* Indikator Slider Web */}
                      <div className="flex justify-center mt-6 space-x-2">
                        {webImages.map((_, idx) => (
                           <button 
                             key={idx} 
                             onClick={() => setWebIndex(idx)} 
                             aria-label={`Slide ${idx + 1}`}
                             className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === webIndex ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600 hover:bg-gray-400'}`}
                           ></button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Mobile App Slider */}
                  <div>
                    <h4 className="text-lg font-bold text-center mb-6 text-gray-900 dark:text-white">Mobile App (Smartphone)</h4>
                    <div className="mx-auto w-[250px] sm:w-[280px]">
                      {/* Frame Smartphone */}
                      <div className="relative bg-gray-800 border-gray-800 border-[10px] rounded-[2.5rem] shadow-xl aspect-[9/19]">
                        {/* Area Poni / Notch */}
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-5 bg-gray-800 rounded-b-xl z-20"></div>
                        
                        <div className="overflow-hidden relative w-full h-full bg-white rounded-[1.8rem] group">
                           <img 
                             src={mobileImages[mobileIndex]} 
                             className="w-full h-full object-cover transition-opacity duration-500" 
                             alt={`Tampilan Mobile ${mobileIndex + 1}`} 
                           />
                           
                           {/* Tombol Manual Kiri & Kanan */}
                           <button onClick={() => setMobileIndex(prev => prev === 0 ? mobileImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 text-white w-8 h-8 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80 font-bold z-30">‹</button>
                           <button onClick={() => setMobileIndex(prev => (prev + 1) % mobileImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 text-white w-8 h-8 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80 font-bold z-30">›</button>
                        </div>
                      </div>
                      
                      {/* Indikator Slider Mobile */}
                      <div className="flex justify-center mt-6 space-x-2">
                        {mobileImages.map((_, idx) => (
                           <button 
                             key={idx} 
                             onClick={() => setMobileIndex(idx)} 
                             aria-label={`Slide ${idx + 1}`}
                             className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === mobileIndex ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600 hover:bg-gray-400'}`}
                           ></button>
                        ))}
                      </div>
                    </div>
                  </div>

               </div>
            </div>

            <div className="mt-12 flex justify-center">
              <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20mau%20tanya%20detail%20tampilan%20dan%20alatnya" target="_blank" rel="noopener noreferrer" className="inline-block bg-blue-600 text-white font-semibold px-8 py-4 rounded-full hover:bg-blue-700 transition-colors shadow-lg">
                Chat Jika Mau Ditanya Lebih Dulu
              </a>
            </div>
          </section>

          {/* 10. TESTIMONI / SOCIAL PROOF */}
          <section className="mb-16">
            <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-4">Alasan Kenapa Orang Mulai Melirik Air Cerdas</h2>
            <p className="text-center text-gray-600 dark:text-gray-400 mb-10 max-w-2xl mx-auto">Karena banyak orang tidak ingin lagi menunggu tagihan datang baru sadar ada masalah. Yang dicari bukan yang rumit, tapi yang membantu cepat sadar dan tidak mahal.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <div className="text-yellow-500 font-bold mb-4 text-lg">5 Bintang</div>
                <p className="italic text-gray-700 dark:text-gray-300 mb-4">"Awalnya saya kira tagihan naik itu biasa. Setelah mulai lebih aware soal pemakaian air, saya jadi jauh lebih tenang."</p>
                <p className="font-bold text-sm text-gray-900 dark:text-white">- Pengguna Air Cerdas</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <div className="text-yellow-500 font-bold mb-4 text-lg">5 Bintang</div>
                <p className="italic text-gray-700 dark:text-gray-300 mb-4">"Yang paling membantu justru karena ada panduan dan dibimbing saat awal pemasangan. Sangat ramah untuk pemula."</p>
                <p className="font-bold text-sm text-gray-900 dark:text-white">- Pengguna Air Cerdas</p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                <div className="text-yellow-500 font-bold mb-4 text-lg">5 Bintang</div>
                <p className="italic text-gray-700 dark:text-gray-300 mb-4">"Cocok untuk saya yang ingin mulai kontrol air di kosan tanpa sistem yang terlalu ribet dan harga bersahabat."</p>
                <p className="font-bold text-sm text-gray-900 dark:text-white">- Pengguna Air Cerdas</p>
              </div>
            </div>
          </section>

          {/* 11. FAQ SECTION */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 md:p-12 rounded-3xl shadow-md border border-gray-100 dark:border-gray-700 transition-colors duration-300 max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-10">Pertanyaan yang Paling Sering Ditanyakan</h2>
            <div className="space-y-4">
              <details className="group border-b border-gray-200 dark:border-gray-700 pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Apakah Air Cerdas cocok untuk rumah saya?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3 animate-fade-in-down">Ya, Air Cerdas cocok untuk rumah, kos, kontrakan, ruko, apartemen kecil, dan tempat lain yang ingin mulai lebih sadar terhadap pemakaian air.</p>
              </details>
              
              <details className="group border-b border-gray-200 dark:border-gray-700 pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Apakah alat ini hanya untuk bangunan besar?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3">Tidak. Justru alat seperti ini sangat berguna untuk kebutuhan yang lebih dekat dengan kehidupan sehari-hari, terutama jika Anda ingin mulai mengontrol biaya air.</p>
              </details>

              <details className="group border-b border-gray-200 dark:border-gray-700 pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Apakah instalasinya sulit?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3">Kami menyediakan video panduan instalasi dan pendampingan sampai alat berhasil terpasang, jadi Anda tidak dibiarkan sendirian.</p>
              </details>

              <details className="group border-b border-gray-200 dark:border-gray-700 pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Kalau saya awam, apakah tetap bisa dibantu?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3">Bisa. Justru salah satu tujuan kami adalah membuat proses awal lebih ramah untuk pengguna yang belum terbiasa.</p>
              </details>

              <details className="group border-b border-gray-200 dark:border-gray-700 pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Harga Rp190.000 per produk itu untuk apa?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3">Itu adalah harga promo per produk untuk memudahkan Anda mulai menggunakan Air Cerdas dengan biaya awal yang lebih ringan.</p>
              </details>

              <details className="group pb-4">
                <summary className="flex justify-between items-center font-bold cursor-pointer list-none text-lg text-gray-900 dark:text-white">
                  <span>Kalau setelah beli saya bingung bagaimana?</span>
                  <span className="transition group-open:rotate-180">
                    <svg fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                  </span>
                </summary>
                <p className="text-gray-600 dark:text-gray-400 mt-3">Anda tetap bisa bertanya. Kami menyediakan video instalasi dan pendampingan agar alat benar-benar bisa digunakan.</p>
              </details>
            </div>
          </section>

          {/* 12. MAP / LOKASI KAMI */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-3xl shadow-md transition-colors duration-300">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white text-center mb-8">Lokasi Kami di Depok, Jawa Barat</h2>
            <div className="aspect-w-16 aspect-h-9 w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-sm border border-gray-200 dark:border-gray-700">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.2106119069576!2d106.8765365793457!3d-6.366784099999989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ed48502a0b5f%3A0x8b3071078865910d!2sAir%20Cerdas!5e0!3m2!1sid!2sid!4v1775400138972!5m2!1sid!2sid" 
                title="Lokasi Penjualan Smart Water Monitor di Depok"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '400px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
            </div>
          </section>

          {/* 13. CLOSING CTA YANG MENEKAN */}
          <section className="text-center mt-16 bg-gray-900 dark:bg-black text-white p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 via-green-500 to-yellow-500"></div>
            
            <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">Jangan Tunggu Tagihan Air Makin Besar Baru Bertindak</h2>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Kalau Anda sudah sering merasa tagihan air naik tanpa alasan yang jelas, terus menunda biasanya hanya membuat masalah yang sama terulang lagi.
              Air Cerdas membantu Anda mulai mengontrol, memantau, dan lebih tenang.
            </p>

            <div className="inline-block bg-white/10 border border-white/20 rounded-2xl p-6 mb-8 backdrop-blur-md">
              <p className="text-sm uppercase tracking-widest text-blue-300 font-bold mb-2">PROMO MULAI HARI INI</p>
              <div className="flex items-center justify-center gap-4 mb-4">
                <span className="text-3xl text-gray-400 line-through">Rp400.000</span>
                <span className="text-5xl font-extrabold text-green-400">Rp190.000</span>
                <span className="text-lg text-gray-300">/ produk</span>
              </div>
              <ul className="text-left text-sm space-y-2 text-gray-200 mt-4 max-w-xs mx-auto">
                <li><span className="font-bold text-green-400 mr-2">✓</span> Dapat video panduan instalasi</li>
                <li><span className="font-bold text-green-400 mr-2">✓</span> Dibimbing sampai alat terpasang</li>
                <li><span className="font-bold text-green-400 mr-2">✓</span> Konsultasi gratis</li>
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
              <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20mau%20Mulai%20Pantau%20Air%20Sekarang%20dengan%20promo%20180rb" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 text-white font-bold px-8 py-4 rounded-full shadow-lg hover:bg-green-700 transform hover:scale-105 transition-all duration-300 text-lg">
                Chat WhatsApp Sekarang
              </a>
              <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20mau%20Konsultasi%20Sebelum%20Beli" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent text-white font-bold px-8 py-4 rounded-full border-2 border-gray-500 hover:border-white hover:bg-white/10 transition-all duration-300 text-lg">
                Saya Mau Konsultasi Dulu
              </a>
            </div>

            {/* Marketplace Buttons - Closing CTA */}
            <div className="pt-8 border-t border-gray-800 w-full max-w-xl mx-auto">
               <p className="text-gray-400 mb-4 text-sm font-medium">Beli sekarang melalui Marketplace:</p>
               <div className="flex flex-col sm:flex-row justify-center gap-4">
                 <a href={tokpedUrl} target="_blank" rel="noopener noreferrer" className="flex-1 bg-[#00AA5B] px-6 py-3 rounded-xl font-bold hover:bg-[#008f4c] transition-colors shadow">
                   Tokopedia
                 </a>
                 <a href={shopeeUrl} target="_blank" rel="noopener noreferrer" className="flex-1 bg-[#EE4D2D] px-6 py-3 rounded-xl font-bold hover:bg-[#d74223] transition-colors shadow">
                   Shopee
                 </a>
               </div>
            </div>
          </section>

        </div>
      </div>

      {/* STICKY CTA MOBILE (Hanya muncul di layar HP) */}
      <div className="fixed bottom-0 left-0 w-full bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 p-3 flex justify-between items-center z-50 md:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
        <div className="flex flex-col">
          <span className="text-xs font-bold text-red-500">Air Cerdas Promo</span>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 line-through">400rb</span>
            <span className="text-lg font-extrabold text-gray-900 dark:text-white">Rp180rb</span>
          </div>
        </div>
        <a href="https://wa.me/6285122019659?text=Halo%2C%20saya%20mau%20order%20Air%20Cerdas%20promo%20180rb" target="_blank" rel="noopener noreferrer" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full text-sm flex items-center gap-1 transition-colors">
           Chat WA
        </a>
      </div>
    </>
  );
};

export default SmartWaterMonitor;